import './AboutView.css'
import '../shared/styles/header.css'

function AboutView() {
    return (
        <div className="aboutView">
            <div className="title">Om Kolla Frukten</div>
            <div className="content">
                <p>Frukt och grönt är godast i säsong. Här presenterar vi säsongens godsaker, månad för månad.</p>
                <p>Världen är global och numera är det alltid säsong, om inte här så i en annan del av världen. Men att frakta långt bidrar till ökade koldioxidutsläpp. Genom att handla när det är säsong hemma gör du en insats för miljön. Vi tipsar om när det är säsong för frukt och grönt i Sverige. Om frukten eller grönsaken inte odlas i Sverige visar vi när den finns i europeisk säsong.</p>
                <p>Använd den här sidan för att få inspiration till middagen eller fruktstunden. Använd den när du undrar hur du ska förvara en morot eller hur du räddar halvruttna bananer.</p>
                <br />
                <p>Mail: <i><a href="mailto:info@kollafrukten.se">info@kollafrukten.se</a></i></p>
                <br /><br />
                <small>Ikoner från <a href="https://www.freepik.com" title="Freepik">Freepik</a> via <a href="https://www.flaticon.com/" title="Flaticon">flaticon.com</a></small>
            </div>
        </div>
    )
}

export default AboutView